import PropTypes from 'prop-types'

import * as moleculeModalApiProps from '@s-ui/react-molecule-modal-v2'
import MoleculeModal from '@s-ui/react-molecule-modal-v2'

const {moleculeModalSizes} = moleculeModalApiProps

export default function ModalBasic({
  buttonPrimary,
  buttonSecondary,
  children,
  closeTrigger: CloseTriggerElement,
  customFooter,
  customHeader,
  isInsetBody = true,
  isInsetScrollArea = false,
  isOpen,
  modal = true,
  onClose,
  onInteractOutside,
  openTrigger: OpenTriggerElement,
  size = moleculeModalSizes.MEDIUM,
  title,
  className = ''
}) {
  const hasCloseTriggerElement = Boolean(CloseTriggerElement)
  const hasFooter =
    Boolean(customFooter) || Boolean(buttonPrimary) || Boolean(buttonSecondary) || hasCloseTriggerElement
  const hasOpenTriggerElement = Boolean(OpenTriggerElement)
  const hasHeader = Boolean(title) || Boolean(customHeader)

  return (
    <MoleculeModal modal={modal} {...(!OpenTriggerElement && {isOpen})}>
      {hasOpenTriggerElement && <MoleculeModal.OpenTrigger>{OpenTriggerElement}</MoleculeModal.OpenTrigger>}
      <MoleculeModal.Overlay />
      <MoleculeModal.Content
        className={className}
        size={size}
        onEscapeKeyDown={onClose}
        onInteractOutside={onInteractOutside || onClose}
      >
        {hasHeader && (
          <MoleculeModal.Header>
            {customHeader ?? <MoleculeModal.Title>{title}</MoleculeModal.Title>}
          </MoleculeModal.Header>
        )}
        <MoleculeModal.Body isInset={isInsetBody}>
          <MoleculeModal.ScrollArea isInset={isInsetScrollArea}>
            <MoleculeModal.Description as="div">{children}</MoleculeModal.Description>
          </MoleculeModal.ScrollArea>
        </MoleculeModal.Body>
        {hasFooter && (
          <MoleculeModal.Footer>
            {customFooter ?? (
              <>
                {hasCloseTriggerElement && (
                  <MoleculeModal.CloseTrigger>{CloseTriggerElement}</MoleculeModal.CloseTrigger>
                )}
                {buttonSecondary}
                {buttonPrimary}
              </>
            )}
          </MoleculeModal.Footer>
        )}
        <MoleculeModal.CloseTrigger>
          <MoleculeModal.CloseIconButton {...(!OpenTriggerElement && {onClick: onClose})} />
        </MoleculeModal.CloseTrigger>
      </MoleculeModal.Content>
    </MoleculeModal>
  )
}

export * from '@s-ui/react-molecule-modal-v2'

ModalBasic.displayName = 'ModalBasic'
ModalBasic.propTypes = {
  buttonPrimary: PropTypes.node,
  buttonSecondary: PropTypes.node,
  children: PropTypes.node,
  closeTrigger: PropTypes.element,
  customFooter: PropTypes.node,
  customHeader: PropTypes.node,
  isInsetBody: PropTypes.bool,
  isInsetScrollArea: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  modal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onInteractOutside: PropTypes.func,
  openTrigger: PropTypes.element,
  size: PropTypes.oneOf(Object.values(moleculeModalSizes || {})),
  title: PropTypes.string,
  className: PropTypes.string
}
